module.exports = __webpack_public_path__ + "static/media/tugbot-logo.500000f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/TugbotLogo/tugbot-logo.svg
// module id = 38
// module chunks = 0